require('./bootstrap')



import Vue from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue'

// Vue.use(InertiaApp)

import { InertiaProgress } from '@inertiajs/progress'

InertiaProgress.init({
  color: '#dc2618',
})


import VuePortal from '@linusborg/vue-simple-portal'

Vue.use(VuePortal, {})

// Vue.config.devtools = true

// TODO: the routes should only be available after login.
// Or: we need to find a way to have two different implementations:
// one for auth and one for logged-in
import { route } from 'ziggy';
import { Ziggy } from './ziggy';
// Vue.prototype.$route = (...args) => route(...args)
Vue.mixin({
  methods: {
    route: (name, params, absolute) => route(name, params, absolute, Ziggy),
  },
});


// TODO: create a custom tooltip directive or maybe find a better one
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

Vue.use(Tooltip, {
  placement: 'body',
  class: 'tooltip-custom',
});


import { Link } from '@inertiajs/inertia-vue';
Vue.component('Link', Link);


import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})


import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)


Vue.filter('formatDateTime', function (date) {
  if (!date) return ''

  var d = new Date(date);

  return d.toLocaleDateString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }) + ' Uhr';
});


Vue.filter('formatDate', function (date) {
  if (!date) return ''

  var d = new Date(date);
  return d.toLocaleDateString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  // return `${d.getDate()}.${d.getFullMonth() + 1}.${d.getFullYear()}`; 
});

Vue.filter('formatTime', function (time) {
  if (!time) return ''

  var t = new Date(time);
  return t.toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit'
  });
});

Vue.filter('formatEuroAmount', function (amount) {
  if (!amount) return ''

  return amount.toFixed(2).replace('.', ',') + ' €';
});

// let app = document.getElementById('app')


createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  setup({ el, App, props, plugin }) {
    Vue.use(plugin)

    new Vue({
      metaInfo: {
        titleTemplate: (title) => title ? `${title} - Markencode Live` : 'Markencode Live'
      },
      render: h => h(App, props),
    }).$mount(el)
  },
})



// new Vue({
//   metaInfo: {
//     titleTemplate: (title) => title ? `${title} - Markencode Live` : 'Markencode Live'
//   },
//   render: h => h(InertiaApp, {
//     props: {
//       initialPage: JSON.parse(app.dataset.page),
//       resolveComponent: (name) => {
//         return import(`@/Pages/${name}`).then(module => module.default)
//       },
//     },
//   }),
// }).$mount(app)





// #############################################


// require('./bootstrap')



// import Vue from 'vue'
// import { createInertiaApp } from '@inertiajs/inertia-vue'

// // Vue.use(InertiaApp)

// import { InertiaProgress } from '@inertiajs/progress'

// InertiaProgress.init({
//   color: '#dc2618',
// })


// import VuePortal from '@linusborg/vue-simple-portal'

// Vue.use(VuePortal, {})

// // Vue.config.devtools = true

// // TODO: the routes should only be available after login.
// // Or: we need to find a way to have two different implementations:
// // one for auth and one for logged-in
// import route from 'ziggy';
// import { Ziggy } from './ziggy';
// // Vue.prototype.$route = (...args) => route(...args)
// Vue.mixin({
//   methods: {
//     route: (name, params, absolute) => route(name, params, absolute, Ziggy),
//   },
// });


// // TODO: create a custom tooltip directive or maybe find a better one
// import Tooltip from 'vue-directive-tooltip';
// import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

// Vue.use(Tooltip, {
//   placement: 'body',
//   class: 'tooltip-custom',
// });


// import { Link } from '@inertiajs/inertia-vue';
// Vue.component('Link', Link);


// import VueMeta from 'vue-meta'

// Vue.use(VueMeta, {
//   refreshOnceOnNavigation: true
// })


// import VueClipboard from 'vue-clipboard2'

// Vue.use(VueClipboard)


// Vue.filter('formatDateTime', function (date) {
//   if (!date) return ''

//   var d = new Date(date);

//   return d.toLocaleDateString('de-DE', {
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit',
//     hour: '2-digit',
//     minute: '2-digit'
//   }) + ' Uhr';
// });


// Vue.filter('formatDate', function (date) {
//   if (!date) return ''

//   var d = new Date(date);
//   return d.toLocaleDateString('de-DE', {
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit',
//   });

//   // return `${d.getDate()}.${d.getFullMonth() + 1}.${d.getFullYear()}`; 
// });

// Vue.filter('formatTime', function (time) {
//   if (!time) return ''

//   var t = new Date(time);
//   return t.toLocaleTimeString('de-DE', {
//     hour: '2-digit',
//     minute: '2-digit'
//   });
// });

// Vue.filter('formatEuroAmount', function (amount) {
//   if (!amount) return ''

//   return amount.toFixed(2).replace('.', ',') + ' €';
// });

// // let app = document.getElementById('app')


// const pages = import.meta.glob('./Pages/**/*.vue', { eager: true })

// createInertiaApp({
//   // resolve: name => require(`./Pages/${name}`),
//   resolve: (name) => pages[`./Pages/${name}.vue`],
//   setup({ el, App, props, plugin }) {
//     Vue.use(plugin)

//     new Vue({
//       metaInfo: {
//         titleTemplate: (title) => title ? `${title} - Markencode Live` : 'Markencode Live'
//       },
//       render: h => h(App, props),
//     }).$mount(el)
//   },
// })



// // new Vue({
// //   metaInfo: {
// //     titleTemplate: (title) => title ? `${title} - Markencode Live` : 'Markencode Live'
// //   },
// //   render: h => h(InertiaApp, {
// //     props: {
// //       initialPage: JSON.parse(app.dataset.page),
// //       resolveComponent: (name) => {
// //         return import(`@/Pages/${name}`).then(module => module.default)
// //       },
// //     },
// //   }),
// // }).$mount(app)
